/* istanbul ignore file - to be imported from @vg-faset/utilities once custom Angular build work is done. */
/*
 * This draws gray horizontal lines in the middle of the chart. It is used instead of gridlines
 * because we want to ensure they are evenly spaced. You can add an option to chart's options
 * object called horizontalLines to change the default from 3 lines.
 */

export default {
  id: 'horizontalLines',
  // eslint-disable-next-line complexity, max-statements
  beforeDatasetsDraw: function (chart) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    let maxLines = 3

    if (typeof chart.config.options.horizontalLines !== 'undefined') {
      maxLines = chart.config.options.horizontalLines
    }

    const ctxPlugin = chart.chart.ctx
    const xAxis = chart.scales[chart.config.options.scales.xAxes[0].id]
    const yAxis = chart.scales[chart.config.options.scales.yAxes[0].id]

    const chartMax = chart.config.options.scales.yAxes[0].ticks.max

    ctxPlugin.strokeStyle = '#eaeaea'

    for (let i = 1; i <= maxLines; i++) {
      ctxPlugin.beginPath()
      let lineAt = (chartMax / (maxLines + 1)) * i
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      lineAt = (lineAt - yAxis.min) * (100 / yAxis.max)
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      lineAt = ((100 - lineAt) / 100) * yAxis.height + yAxis.top
      ctxPlugin.moveTo(xAxis.left, lineAt)
      ctxPlugin.lineTo(xAxis.right, lineAt)
      ctxPlugin.stroke()
    }
  },
}
